import styles from "./stable.module.css";
import DOMPurify from "dompurify";

const Stable = ({ textData, setImgLoadComplate ,language}) => {
  return (
    <div className={styles.ctn}>
      <div className={styles.textBox}>
        <h1
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text6"]),
          }}
        ></h1>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text7"]),
          }}
        ></h5>
      </div>

      <div className={styles.videoBox}>
        {/* <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text8"]),
          }}
          className={styles.mobile}
        ></div>
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text9"]),
          }}
          className={styles.stabilizer}
        ></div> */}
        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-4-poster${language === 'cn' ? '' : '-en'}.jpg`}
          src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-4${language === 'cn' ? '' : '-en'}.mp4`}

          // src="https://bucket.zhiyun-tech.com/detail/m2s/M2S.mp4"
        ></video>
      </div>
    </div>
  );
};

export default Stable;
